<template>
  <svg
    width="28"
    height="29"
    viewBox="0 0 28 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4730_3848)">
      <circle
        cx="13.7227"
        cy="14.5527"
        r="13"
        fill="#9974DC"
      />
      <rect
        width="20.622"
        height="3.12043"
        transform="translate(3.96777 20.7324)"
        fill="#EE3B3B"
      />
      <path
        d="M21.8169 20.7986L6.82281 20.889L6.7915 13.4248L7.38415 10.3476L10.1033 8.1412L14.0427 7.24121L18.0169 8.11213L20.8407 10.2024L21.6774 12.641L21.8169 20.7986Z"
        fill="#FFAA33"
      />
      <path
        d="M17.0561 10.1968C16.8422 10.0586 16.5539 10.1122 16.4097 10.3172C16.2654 10.5222 16.3213 10.7984 16.5352 10.9367C17.977 11.8727 18.8419 13.4235 18.8419 15.0861C18.8419 15.3313 19.0512 15.5318 19.3069 15.5318C19.5627 15.5318 19.7719 15.3313 19.7719 15.0861C19.7721 13.1251 18.7535 11.2978 17.0561 10.1967L17.0561 10.1968Z"
        fill="#28293D"
        stroke="#28293D"
        stroke-width="0.2"
        stroke-linejoin="round"
      />
      <path
        d="M15.3353 9.4217C14.7772 9.26576 14.2005 9.18555 13.6144 9.18555C13.3587 9.18555 13.1494 9.38607 13.1494 9.63118C13.1494 9.87628 13.3587 10.0768 13.6144 10.0768C14.1121 10.0768 14.605 10.1436 15.0749 10.2773C15.1167 10.2908 15.1632 10.2952 15.2051 10.2952C15.405 10.2952 15.5911 10.1704 15.6516 9.9744C15.7213 9.73806 15.5817 9.49295 15.3353 9.4217L15.3353 9.4217Z"
        fill="#28293D"
        stroke="#28293D"
        stroke-width="0.2"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.73165 24.8927H26.6951C26.9945 24.8927 27.2378 24.6596 27.2378 24.3726C27.2378 24.0856 26.9945 23.8525 26.6951 23.8525H1.73165C1.4322 23.8525 1.18896 24.0856 1.18896 24.3726C1.18896 24.6596 1.4322 24.8927 1.73165 24.8927Z"
        fill="#28293D"
        stroke="#28293D"
        stroke-width="0.2"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.5243 21.1109C24.5243 20.8239 24.2811 20.5908 23.9816 20.5908H4.44503C4.14558 20.5908 3.90234 20.8239 3.90234 21.1109V24.3727C3.90234 24.6597 4.14558 24.8928 4.44503 24.8928H23.9816C24.2811 24.8928 24.5243 24.6597 24.5243 24.3727V21.1109ZM4.98771 21.631V23.8526H23.4389V21.631H4.98771Z"
        fill="#28293D"
        stroke="#28293D"
        stroke-width="0.2"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.354 13.5079C22.354 9.71217 18.7092 6.63477 14.2137 6.63477H14.2127C9.71765 6.63477 6.07373 9.71175 6.07373 13.5069V21.1729C6.07373 21.4257 6.31697 21.6311 6.61641 21.6311H21.8115C22.111 21.6311 22.3542 21.4257 22.3542 21.1729L22.354 13.5079ZM21.2686 20.7147V13.5079C21.2686 10.218 18.1101 7.55119 14.2137 7.55119H14.2127C10.3168 7.55119 7.1591 10.2176 7.1591 13.5069V20.7147H21.2686Z"
        fill="#28293D"
        stroke="#28293D"
        stroke-width="0.2"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.00165 4.32173L6.92063 6.16011C7.13238 6.36303 7.4764 6.36303 7.6879 6.16011C7.89964 5.95719 7.89964 5.6275 7.6879 5.42482L5.76959 3.58579C5.55736 3.38286 5.21382 3.38286 5.00158 3.58579C4.78984 3.78917 4.78984 4.11839 5.00158 4.32179L5.00165 4.32173Z"
        fill="#28293D"
        stroke="#28293D"
        stroke-width="0.2"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.6552 3.58487L20.7369 5.4239C20.5252 5.62682 20.5252 5.95651 20.7369 6.15919C20.9487 6.36212 21.2927 6.36212 21.5042 6.15919L23.4232 4.32081C23.6349 4.11743 23.6349 3.78821 23.4232 3.58481C23.211 3.38189 22.8674 3.38189 22.6552 3.58481L22.6552 3.58487Z"
        fill="#28293D"
        stroke="#28293D"
        stroke-width="0.2"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.7553 4.09016V1.4898C14.7553 1.20283 14.512 0.969727 14.2126 0.969727C13.9132 0.969727 13.6699 1.20283 13.6699 1.4898V4.09016C13.6699 4.37712 13.9132 4.61023 14.2126 4.61023C14.512 4.61023 14.7553 4.37712 14.7553 4.09016Z"
        fill="#28293D"
        stroke="#28293D"
        stroke-width="0.2"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.76973 12.9317H4.48315C4.78259 12.9317 5.02583 12.6986 5.02583 12.4117C5.02583 12.1247 4.78259 11.8916 4.48315 11.8916H1.76973C1.47029 11.8916 1.22705 12.1247 1.22705 12.4117C1.22705 12.6986 1.47029 12.9317 1.76973 12.9317Z"
        fill="#28293D"
        stroke="#28293D"
        stroke-width="0.2"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.0207 12.9317H26.7341C27.0336 12.9317 27.2768 12.6986 27.2768 12.4117C27.2768 12.1247 27.0336 11.8916 26.7341 11.8916H24.0207C23.7213 11.8916 23.478 12.1247 23.478 12.4117C23.478 12.6986 23.7213 12.9317 24.0207 12.9317Z"
        fill="#28293D"
        stroke="#28293D"
        stroke-width="0.2"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4730_3848">
        <rect
          width="28"
          height="28"
          fill="white"
          transform="translate(0 0.261719)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
